import { combineReducers } from 'redux';
import { getPlayersById } from '../players/utils';
import { getTeamsById } from '../heatStreak/utils';

const getCurrentChallenge = (challenges = {}) => {
  for (const [challenge] of Object.keys(challenges)) {
    if (challenges[challenge]?.status === 'current') {
      return challenges[challenge];
    }
  }
  return challenges[Object.keys(challenges).length.toString()];
};

const data = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_HISTORY_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
};

const byDate = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_HISTORY_DATA_SUCCESS':
      // Boom mocks may omit `history`; keep the empty object shape the UI expects.
      return (action.resp?.history || []).reduce((acc, curr) => {
        if (!curr?.contestDate) {
          return acc;
        }
        const getMonth = parseFloat(curr.contestDate.substring(5, 6));
        const getDay = parseFloat(curr.contestDate.substring(8, 9));

        const month = !getMonth ? curr.contestDate.substring(6, 7) : curr.contestDate.substring(5, 7);

        const day = !getDay ? curr.contestDate.substring(9, 10) : curr.contestDate.substring(8, 10);

        return {
          ...acc,
          [curr.contestDate]: {
            ...curr,
            picks: curr.picks || [],
            month,
            day,
          },
        };
      }, {});
    default:
      return state;
  }
};

const streak = (state = 0, action) => {
  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS': {
      return action.resp?.scoringStreak || 0;
    }
    default:
      return state;
  }
};

const percentage = (state = 0, action) => {
  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS': {
      const streak = action.resp?.scoringStreak || 0;
      return (streak / 7) * 100;
    }
    default:
      return state;
  }
};

const challengeStats = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS': {
      const currentChallenge = getCurrentChallenge(action.resp?.challenges);
      if (currentChallenge) {
        return {
          challenge: currentChallenge.challengeNumber,
          pickAccuracy: currentChallenge.pickAccuracy,
          daysPlayed: currentChallenge.daysPlayed,
          correctPicks: currentChallenge.correctPicks,
          rank: currentChallenge.rank,
          rankChange: currentChallenge.rankChange,
        };
      } else {
        return state;
      }
    }
    default:
      return state;
  }
};

const challenges = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS': {
      return action.resp?.challenges ?? null;
    }
    default:
      return state;
  }
};

const byPlayerId = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_HISTORY_DATA_SUCCESS':
      return getPlayersById(action.resp?.teams);
    default:
      return state;
  }
};

const byTeamId = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_HISTORY_DATA_SUCCESS':
      return getTeamsById(action.resp?.teams);
    default:
      return state;
  }
};

export default combineReducers({
  data,
  byDate,
  streak,
  percentage,
  challengeStats,
  challenges,
  byPlayerId,
  byTeamId,
});
